const categories = [{
		id: 1,
		name: '汽车组件类'
	},
	{
		id: 2,
		name: '家用电器类'
	},
	{
		id: 3,
		name: '厨房电器类'
	},
	{
		id: 4,
		name: '电视机类'
	},
	{
		id: 5,
		name: '笔记本电脑类'
	},
]

const products = [

	// 1---- 汽车组件类
	// 汽车天窗
	{
		id: 1,
		name: '汽车天窗',
		category: 1,
		description: '最新款智能手机',
		image: require('@/assets/imgs/products/汽车天窗1.jpg'),
	},
	{
		id: 1,
		name: '汽车天窗',
		category: 1,
		description: '最新款智能手机',
		image: require('@/assets/imgs/products/汽车天窗2.jpg'),
	},
	{
		id: 1,
		name: '汽车天窗',
		category: 1,
		description: '最新款智能手机',
		image: require('@/assets/imgs/products/汽车天窗3.jpg'),
	},
	// 门铰链
	{
		id: 1,
		name: '门铰链',
		category: 1,
		description: '最新款智能手机',
		image: require('@/assets/imgs/products/门铰链1.jpg'),
	},
	{
		id: 1,
		name: '门铰链',
		category: 1,
		description: '最新款智能手机',
		image: require('@/assets/imgs/products/门铰链2.jpg'),
	},
	// 汽车滑轨
	{
		id: 1,
		name: '汽车滑轨',
		category: 1,
		description: '最新款智能手机',
		image: require('@/assets/imgs/products/汽车滑轨1.jpg'),
	},
	{
		id: 1,
		name: '汽车滑轨',
		category: 1,
		description: '最新款智能手机',
		image: require('@/assets/imgs/products/汽车滑轨2.jpg'),
	},
	// 新能源汽车电池壳
	{
		id: 1,
		name: '新能源汽车电池壳',
		category: 1,
		description: '最新款智能手机',
		image: require('@/assets/imgs/products/新能源汽车电池壳.jpg'),
	},
	// 新能源汽车电池冷却板
	{
		id: 1,
		name: '新能源汽车电池壳',
		category: 1,
		description: '最新款智能手机',
		image: require('@/assets/imgs/products/新能源汽车电池壳.jpg'),
	},

	// 2---- 家用电器类
	{
		id: 2,
		name: '家用电器',
		category: 2,
		description: '高性能平板',
		image: require('@/assets/imgs/products/家用电器1.jpg'),
	},
	{
		id: 2,
		name: '家用电器',
		category: 2,
		description: '高性能平板',
		image: require('@/assets/imgs/products/家用电器2.jpg'),
	},
	{
		id: 2,
		name: '家用电器',
		category: 2,
		description: '高性能平板',
		image: require('@/assets/imgs/products/家用电器3.jpg'),
	},
	{
		id: 2,
		name: '家用电器',
		category: 2,
		description: '高性能平板',
		image: require('@/assets/imgs/products/家用电器4.jpg'),
	},
	{
		id: 2,
		name: '家用电器',
		category: 2,
		description: '高性能平板',
		image: require('@/assets/imgs/products/家用电器5.jpg'),
	},
	{
		id: 2,
		name: '家用电器',
		category: 2,
		description: '高性能平板',
		image: require('@/assets/imgs/products/家用电器6.jpg'),
	},

	// 3-----厨房电器类
	{
		id: 3,
		name: '厨房电器',
		category: 3,
		description: '4K超高清电视',
		image: require('@/assets/imgs/products/厨房电器1.jpg'),
	},
	{
		id: 3,
		name: '厨房电器',
		category: 3,
		description: '4K超高清电视',
		image: require('@/assets/imgs/products/厨房电器2.jpg'),
	},
	{
		id: 3,
		name: '厨房电器',
		category: 3,
		description: '4K超高清电视',
		image: require('@/assets/imgs/products/厨房电器3.jpg'),
	}, {
		id: 3,
		name: '厨房电器',
		category: 3,
		description: '4K超高清电视',
		image: require('@/assets/imgs/products/厨房电器4.jpg'),
	},

	// 4----电视机类
	{
		id: 4,
		name: '电视机背板',
		category: 4,
		description: '节能空调',
		image: require('@/assets/imgs/products/电视机背板1.jpg'),
	},
	{
		id: 4,
		name: '电视机背板',
		category: 4,
		description: '节能空调',
		image: require('@/assets/imgs/products/电视机背板2.jpg'),
	},
	{
		id: 4,
		name: '电视机背板',
		category: 4,
		description: '节能空调',
		image: require('@/assets/imgs/products/电视机背板3.jpg'),
	},
	{
		id: 4,
		name: '电视机背板',
		category: 4,
		description: '节能空调',
		image: require('@/assets/imgs/products/电视机背板4.jpg'),
	},

	// 5----笔记本电脑类
	{
		id: 5,
		name: '笔记本电脑',
		category: 5,
		description: '高效打印机',
		image: require('@/assets/imgs/products/电视机背板1.jpg'),
	},
	{
		id: 5,
		name: '笔记本电脑',
		category: 5,
		description: '高效打印机',
		image: require('@/assets/imgs/products/电视机背板2.jpg'),
	},
	{
		id: 5,
		name: '笔记本电脑',
		category: 5,
		description: '高效打印机',
		image: require('@/assets/imgs/products/电视机背板3.jpg'),
	}
]

export {
	categories,
	products
};
